import React, { useEffect, useState } from 'react';
import { getJustificante } from '../../services/revisarAplazamientoService';

// Visor embebido del justificante (imagen o PDF) con descarga como opción secundaria.
export default function VisorJustificante({ solicitudId, nombre, tipo }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let vigente = true;
    let creada = null;
    getJustificante(solicitudId)
      .then((blob) => {
        if (!vigente) return;
        // El tipo lo fija la API (validado por firma al subir); aquí se reafirma para el blob.
        creada = URL.createObjectURL(new Blob([blob], { type: tipo }));
        setUrl(creada);
      })
      .catch((err) => vigente && setError(err.message || 'No se pudo cargar el justificante.'));
    return () => {
      vigente = false;
      if (creada) URL.revokeObjectURL(creada);
    };
  }, [solicitudId, tipo]);

  if (error) return <p className="msg-error" role="alert">{error}</p>;
  if (!url) return <p className="mz-vacio">Cargando justificante…</p>;

  return (
    <div className="ra-visor">
      {tipo === 'application/pdf' ? (
        <iframe className="ra-visor-pdf" src={url} title={`Justificante: ${nombre}`} />
      ) : (
        <img className="ra-visor-img" src={url} alt={`Justificante: ${nombre}`} />
      )}
      <a className="btn btn-secondary btn-sm" href={url} download={nombre}>Descargar</a>
    </div>
  );
}
